export default {"src":"/_next/static/media/AL.8bde2187.svg","height":18,"width":18};